module.exports = __webpack_public_path__ + "static/cabraCSS2-1cd1e67d58126b7d9be12d33e8522d88.png";